import * as Yup from 'yup';
export const MonHocSchema = Yup.object().shape({
    Ky_hieu: Yup.string().required('Ký hiệu môn là bắt buộc'),
    Ten_mon: Yup.string().required('Tên môn là bắt buộc'),
    So_tin_chi: Yup.number().required().min(1, 'Ít nhất 1 tín chỉ'),
    Ly_thuyet: Yup.number().min(0),
    Thuc_hanh: Yup.number().min(0)
});
